// extracted by mini-css-extract-plugin
export default {"quickSearchTags":"SearchTagsContainer_quickSearchTags__VUON4"};